import { IDisbursementFormData } from 'types/order/escrow/IDisbursementFormData';
import { useProcessWire } from './wires/useProcessWire';
import { assertDefined } from 'utilities/Assertions';
import { useProcessCheck } from './checks/useProcessCheck';
import { useProcessACH } from './ach/useProcessACH';
import { useProcessInternalTransfer } from './internalTransfers/useProcessInternalTransfers';
import { useGetDetailedEscrowDataQuery } from 'API/order/escrow/EscrowBaseAPI';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';

export const useProcessDisbursement = (orderId: string) => {
  const processWire = useProcessWire();
  const processCheck = useProcessCheck();
  const processACH = useProcessACH();
  const { data } = useGetDetailedEscrowDataQuery(orderId);
  const processInternalTransfer = useProcessInternalTransfer(orderId, data);

  return async (disbursement: IDisbursementFormData) => {
    const { id: escrowFileId } = data ?? {};
    assertDefined(escrowFileId);

    switch (disbursement.type) {
      case eDisbursementType.ACH:
        return processACH(escrowFileId, orderId, disbursement);
      case eDisbursementType.Wire:
        return processWire(escrowFileId, orderId, disbursement);
      case eDisbursementType.Check:
        return processCheck(escrowFileId, orderId, disbursement);
      case eDisbursementType.InternalTransfer:
        return processInternalTransfer(disbursement);
    }
  };
};
